import { ONLY_NUMBER_REGEX } from '../../../constants/defaults';
import bffcli from '../bffcli';

export const fetchPrices = async (drugs, zipcode) => {
  try {
    let data = {
      tenantId: 0,
      drugs: drugs
    };
    if (ONLY_NUMBER_REGEX.test(zipcode)) {
      data.zipcode = zipcode;
    } else {
      (data.lat = zipcode?.coordinate?.latitude),
        (data.lon = zipcode.coordinate?.longitude);
    }
    const fetchPriceResponse = await bffcli.post(
      '/fetch-multi-drug-pricing',
      data
    );
    return fetchPriceResponse?.data;
  } catch (err) {
    console.log('error while getting fetchPrices', err);
    return;
  }
};
